'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/prop-types/~/react-is/index.js
// module id = 392
// module chunks = 6